import React from 'react';
import Footer from '../../footer';
import Header from '../../header';
import '../../../assets/styles/languages/languagefontfamily.css';

export default function DefaultLayout({children}) {
  return (
    <div className="pf-language">
      <Header />
      {children}
      <Footer />
    </div>
  );
}
